import DatePicker from 'react-datepicker';
import { isClosedDate, isPickerTimeAvailable, temporaryClosureMessageKey } from '../booking-availability';

export function Step1Dates({ formData, updateFormData, t }) {
    /* -----------------------------
     * Helpers
     * ----------------------------- */

    const pad = (n) => String(n).padStart(2, '0');

    const splitDateTime = (date) => {
        if (!date) {
            return { date: '', time: '' };
        }

        return {
            date: `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
            time: `${pad(date.getHours())}:${pad(date.getMinutes())}`,
        };
    };

    const getDateFromForm = (field) => {
        const date = formData[`${field}_date`];
        const time = formData[`${field}_time`];

        if (!date) return null;

        return new Date(`${date}T${time || '00:00'}`);
    };

    /* -----------------------------
     * Handlers
     * ----------------------------- */

    const handleDateTimeChange = (field, date) => {
        const { date: d, time: t } = splitDateTime(date);

        updateFormData({
            [`${field}_date`]: d,
            [`${field}_time`]: t,
        });
    };

    /* -----------------------------
     * Constraints
     * ----------------------------- */

    const now = new Date();
    const checkinDate = getDateFromForm('checkin');
    const checkoutDate = getDateFromForm('checkout');

    // $ Opening Hours from 7 to 22
    const minTime = new Date();
    minTime.setHours(7, 0, 0, 0);
    const maxTime = new Date();
    maxTime.setHours(22, 0, 0, 0);

    /* -----------------------------
     * Render
     * ----------------------------- */

    return (
        <div className="step-content">
            <h3 className="mb-3">{t('stepper.step1.title')}</h3>

            {(isClosedDate(formData.checkin_date) || isClosedDate(formData.checkout_date)) && (
                <p role="status">{t(temporaryClosureMessageKey)}</p>
            )}

            <div className="d-flex flex-column mt-1">
                {/* CHECK-IN */}
                <div className="col-12 form-group">
                    <DatePicker
                        selected={checkinDate}
                        filterTime={isPickerTimeAvailable}
                        ariaLabelledBy="checkin-label"
                        onChange={(date) => handleDateTimeChange('checkin', date)}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={30}
                        dateFormat={
                            formData.checkin_date && !formData.checkin_time
                                ? ['yyyy-MM-dd', 'yyyy-MM-dd HH:mm']
                                : 'yyyy-MM-dd HH:mm'
                        }
                        minTime={minTime}
                        maxTime={maxTime}
                        minDate={now}
                        maxDate={checkoutDate}
                        placeholderText={t('contact.fields.date.placeholder')}
                        className="form-control"
                        required
                        calendarStartDay={1}
                    />
                    <label id="checkin-label" className="form__label">
                        Check-in *
                    </label>
                </div>

                {/* CHECK-OUT */}
                <div className="col-12 form-group mt-1 mt-md-0">
                    <DatePicker
                        selected={checkoutDate}
                        filterTime={isPickerTimeAvailable}
                        ariaLabelledBy="checkout-label"
                        onChange={(date) => handleDateTimeChange('checkout', date)}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={30}
                        dateFormat={
                            formData.checkout_date && !formData.checkout_time
                                ? ['yyyy-MM-dd', 'yyyy-MM-dd HH:mm']
                                : 'yyyy-MM-dd HH:mm'
                        }
                        minDate={checkinDate || now}
                        minTime={minTime}
                        maxTime={maxTime}
                        placeholderText={t('contact.fields.date.placeholder')}
                        className="form-control"
                        required
                        calendarStartDay={1}
                    />
                    <label id="checkout-label" className="form__label">
                        Check-out *
                    </label>
                </div>
            </div>
        </div>
    );
}
